import { PageHeader } from '@/components/PageHeader';
import { AILearningDashboard } from '@/components/AILearningDashboard';

export default function AILearning() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="AI Learning & Feedback"
        description="Monitor and improve AI performance through learning feedback"
      />
      <AILearningDashboard />
    </div>
  );
}